import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES, BLOCKS } from '@contentful/rich-text-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
interface ContentfulContentProps {
  content: any;
  classNames?: string;
}

const ContentfulContent: React.FC<ContentfulContentProps> = props => {
  const websiteUrl = 'https://readingandwritingproject.org';
  const options = {
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: (node: any) => {
        const image = node.data?.target?.fields?.file['en-US'];

        if (image) {
          return (
            <div>
              <img src={image.url} />
            </div>
          );
        }
      },
      [BLOCKS.EMBEDDED_ENTRY]: (node: any) => {
        if (!node.data.target.fields.downloadLink) {
          return null;
        }
        return (
          <div className="border border-gray-200 rounded-lg p-4">
            <a
              href={node.data.target.fields.downloadLink['en-US']}
              target="_blank"
              className=""
            >
              <span className="font-bold text-primary hover:underline cursor-pointer">
                {node.data.target.fields.title['en-US']}
              </span>
              <span className="ml-2 text-primary text-sm">
                <FontAwesomeIcon icon={faExternalLinkAlt} />
              </span>
            </a>
          </div>
        );
      },
      [INLINES.HYPERLINK]: (node: any) => {
        if (node.data.uri.includes('youtube.com/embed')) {
          return (
            <div className="mb-10">
              <iframe
                className="rounded-lg m-auto"
                width="560"
                height="315"
                src={node.data.uri}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              ></iframe>
            </div>
          );
        }
        return (
          <a
            href={node.data.uri}
            target={`${
              node.data.uri.startsWith(websiteUrl) ? '_self' : '_blank'
            }`}
            rel={`${
              node.data.uri.startsWith(websiteUrl) ? '' : 'noopener noreferrer'
            }`}
          >
            {node.content[0].value}
          </a>
        );
      },
      [INLINES.ENTRY_HYPERLINK]: (node: any) => {
        if (!node.data.target.fields || !node.data.target.fields.downloadLink) {
          return <>{node.content[0].value}</>;
        }
        return (
          <a
            href={node.data.target.fields.downloadLink['en-US']}
            target="_blank"
          >
            {node.content[0].value}
          </a>
        );
      }
    }
  };
  if (!props.content) {
    return null;
  }
  return (
    <div className={props.classNames}>
      {documentToReactComponents(JSON.parse(props.content), options)}
    </div>
  );
};

export default ContentfulContent;
